class CreateCustomer extends HTMLElement {
    constructor() {
        super();
        var form = this.querySelector('#register');

        form.addEventListener('submit', () => {
            history.back(-2)
        })
    }
}

customElements.define('create-customer', CreateCustomer);